import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { UsersThree } from '@phosphor-icons/react';
import Layout from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';
import EquipeCabinet from './EquipeMOE';
import ComptesListe from '../components/equipe/ComptesListe';
import EnvoisEnPause from '../components/equipe/EnvoisEnPause';
import { ONGLETS_EQUIPE_ACCES } from '../lib/libelles';

const AIDE_ONGLET = {
  partenaires: "Partenaires (BET, contrôleur technique, SPS, OPC, économiste…) et AMO. Ils s'invitent depuis l'équipe du projet (Équipe du projet › Inviter un AMO ou un partenaire).",
  entreprises: "Comptes des entreprises et de leurs salariés. Les entreprises s'ajoutent depuis l'annuaire.",
  clients: "Clients (MOA) ayant un compte. Ils sont invités quand on ajoute un propriétaire à un chantier.",
};

/**
 * RP84-85 (ADM-A2, ADM-R3) — Écran unique « Équipe & accès » : remplace Paramètres ›
 * Utilisateurs, Paramètres › Accès & Invitations, la page Équipe MOE et la page Clients
 * (les routes /equipe et /clients redirigent ici). Onglets Cabinet, Partenaires,
 * Entreprises, Clients ; l'onglet est gardé dans l'adresse (?onglet=…).
 */
export default function EquipeAcces() {
  const { user, isAdmin, canEdit } = useAuth();
  const [params, setParams] = useSearchParams();
  const demande = params.get('onglet');
  const onglet = ONGLETS_EQUIPE_ACCES.some((o) => o.id === demande) ? demande : 'cabinet';
  // Réservé au personnel du cabinet (comme GET /api/equipe-acces/comptes)
  if (user && !canEdit) return <Navigate to="/dashboard" replace />;

  return (
    <Layout>
      <div className="p-4 sm:p-6 lg:p-8 space-y-5" data-testid="equipe-acces-page">
        <div>
          <h1 className="text-2xl sm:text-3xl text-[#2C2C2C] flex items-center gap-3" style={{ fontFamily: 'DM Serif Display, serif' }}>
            <UsersThree size={28} className="text-[#C4773B]" weight="fill" />
            Équipe &amp; accès
          </h1>
          <p className="text-sm text-[#6B6B6B] mt-1">
            Qui a accès à Kroquis : inviter, renvoyer une invitation, désactiver ou réactiver un compte.
          </p>
        </div>

        {isAdmin && <EnvoisEnPause />}

        <div className="flex flex-wrap gap-2 border-b border-[#E0E0DB]" role="tablist">
          {ONGLETS_EQUIPE_ACCES.map((o) => (
            <button
              key={o.id}
              type="button"
              role="tab"
              aria-selected={onglet === o.id}
              onClick={() => setParams({ onglet: o.id }, { replace: true })}
              className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${onglet === o.id ? 'border-[#C4773B] text-[#2C2C2C]' : 'border-transparent text-[#6B6B6B] hover:text-[#2C2C2C]'}`}
              data-testid={`equipe-acces-onglet-${o.id}`}
            >
              {o.nom}
            </button>
          ))}
        </div>

        {onglet === 'cabinet' && <EquipeCabinet />}
        {onglet !== 'cabinet' && (
          <div className="space-y-3">
            <p className="text-sm text-[#6B6B6B]">
              {AIDE_ONGLET[onglet]}
              {onglet === 'entreprises' && <> <Link to="/entreprises" className="underline text-[#1E3A5F]">Ouvrir l'annuaire des entreprises</Link></>}
            </p>
            <ComptesListe key={onglet} groupe={onglet} />
          </div>
        )}
      </div>
    </Layout>
  );
}
